// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"705":"29e7b9b8","4101":"440e29e0"}[chunkId] + ".chunk.css";
};